import { useEffect } from 'react';
import { FaHome, FaAngleDoubleLeft, FaAngleLeft, FaAngleRight, FaAngleDoubleRight } from 'react-icons/fa';
import $ from 'jquery';
import styled from 'styled-components';

const TableComp = ({ className, tablesorter }) => {
	useEffect(() => {
		$('#myTable')
			.tablesorter({
				theme: 'ice',
				widgets: ['filter', 'zebra', 'cssStickyHeaders', 'pager'],
				widgetOptions: { cssStickyHeaders_attachTo: '.table-container', uitheme: 'jui' },
			})
			.tablesorterPager({
				// target the pager markup - see the HTML block below
				container: $('.pager'),

				// output string - default is '{page}/{totalPages}';
				// possible variables:
				// {page}, {totalPages}, {startRow}, {endRow} and {totalRows}
				output: '{page}/{totalPages} ({startRow}-{endRow})',

				// apply disabled classname to the pager arrows when the rows at
				// either extreme is visible - default is true
				updateArrows: true,

				// starting page of the pager (zero based index)
				page: 0,

				// Number of visible rows - default is 10
				size: 10,

				// if true, the table will remain the same height no matter how many
				// records are displayed. The space is made up by an empty
				// table row set to a height to compensate; default is false
				fixedHeight: true,

				// remove rows from the table to speed up the sort of large tables.
				// setting this to false, only hides the non-visible rows; needed
				// if you plan to add/remove rows with the pager enabled.
				removeRows: false,

				// css class names of pager arrows
				// next page arrow
				cssNext: '.next',
				// previous page arrow
				cssPrev: '.prev',
				// go to first page arrow
				cssFirst: '.first',
				// go to last page arrow
				cssLast: '.last',
				// select dropdown to allow choosing a page
				cssGoto: '.gotoPage',
				// location of where the "output" is displayed
				cssPageDisplay: '.pagedisplay',
				// dropdown that sets the "size" option
				cssPageSize: '.pagesize',
				// class added to arrows when at the extremes
				// (i.e. prev/first arrows are "disabled" when on the first page)
				// Note there is no period "." in front of this class name
				cssDisabled: 'disabled',
			});
	});
	let classes = { className };
	if (tablesorter) {
		classes += 'tablesorter';
	}

	return (
		<table id="myTable" class={classes} style={{ width: '100%' }}>
			<thead>
				<tr>
					<th>Task</th>
					<th>Daily</th>
					<th>Weekly</th>
					<th>Monthly</th>
					<th>Quarterly</th>
					<th>Biannually</th>
					<th>Annually</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td>Verify that all safety devices are functioning properly.</td>
					<td>X</td>
					<td>-</td>
					<td>-</td>
					<td>-</td>
					<td>-</td>
					<td>-</td>
				</tr>
				<tr>
					<td>Check all emergency stop push buttons for function and indicator lamp illumination. Repair or replace non-functioning push buttons and lamps.</td>
					<td>X</td>
					<td>-</td>
					<td>-</td>
					<td>-</td>
					<td>-</td>
					<td>-</td>
				</tr>
				<tr>
					<td>Check all indicator lights on the electrical panels for burned out light bulbs.</td>
					<td>X</td>
					<td>-</td>
					<td>-</td>
					<td>-</td>
					<td>-</td>
					<td>-</td>
				</tr>
				<tr>
					<td>Check electrical panel for spare fuses and I/O fuses. Make sure they are not blown.</td>
					<td>-</td>
					<td>X</td>
					<td>-</td>
					<td>-</td>
					<td>-</td>
					<td>-</td>
				</tr>
				<tr>
					<td>Check terminals and connectors for looseness or signs of overheating. If there is evidence of overheating, termination points should be cleaned or replaced.</td>
					<td>-</td>
					<td>X</td>
					<td>-</td>
					<td>-</td>
					<td>-</td>
					<td>-</td>
				</tr>
				<tr>
					<td>Limit switches: Check for proper trip position, location and operation.</td>
					<td>-</td>
					<td>X</td>
					<td>-</td>
					<td>-</td>
					<td>-</td>
					<td>-</td>
				</tr>
				<tr>
					<td>Proximity switches: Check for presence of debris on unit. Clean proximity switches as needed to maintain system uptime. Check for loose connections and damaged housings. Tighten where needed and replace unit if defective.</td>
					<td>-</td>
					<td>X</td>
					<td>-</td>
					<td>-</td>
					<td>-</td>
					<td>-</td>
				</tr>
				<tr>
					<td>Wiring: Check for broken, loose, and damaged wires. Check all electrical cables for signs of damage and make sure all connections are tight and secure.</td>
					<td>-</td>
					<td>-</td>
					<td>X</td>
					<td>-</td>
					<td>-</td>
					<td>-</td>
				</tr>
				<tr>
					<td>Light curtains: Inspect interconnecting electrical and data cables for evidence of wear or damage. Replace if necessary. Clean the lenses using a clean soft cloth moistened with 70-100% isopropyl alcohol or an equivalent non-abrasive glass cleaner.</td>
					<td>-</td>
					<td>-</td>
					<td>X</td>
					<td>-</td>
					<td>-</td>
					<td>-</td>
				</tr>
				<tr>
					<td>Electrical enclosures: Wipe and clean the inside of the main electrical enclosures. Check for obvious signs of damage and repair as necessary.</td>
					<td>-</td>
					<td>-</td>
					<td>-</td>
					<td>X</td>
					<td>-</td>
					<td>-</td>
				</tr>
				<tr>
					<td>Wipe and clean the inside of the electrical control enclosure and all junction boxes. Check for signs of damage.</td>
					<td>-</td>
					<td>-</td>
					<td>-</td>
					<td>-</td>
					<td>-</td>
					<td>-</td>
				</tr>
				<tr>
					<td>Disconnect assembly: Verify the disconnect function. Check for loose, bent, or broken components.</td>
					<td>-</td>
					<td>-</td>
					<td>-</td>
					<td>X</td>
					<td>-</td>
					<td>-</td>
				</tr>
				<tr>
					<td>Circuit breakers: Inspect for loose or broken terminals. Check for the presence of contaminants like dirt, dust, grease, or rust. Remove dust, dirt, soot, grease, or moisture from the surface of the circuit breaker using a lint-free dry cloth, brush, or vacuum cleaner If contamination is found, look for the source and eliminate the problem.</td>
					<td>-</td>
					<td>-</td>
					<td>-</td>
					<td>X</td>
					<td>-</td>
					<td>-</td>
				</tr>
				<tr>
					<td>Power distribution blocks: Verify blocks are tight and free of corrosion. Check for presence of contaminants like: dirt, dust, grease, or rust.</td>
					<td>-</td>
					<td>-</td>
					<td>-</td>
					<td>X</td>
					<td>-</td>
					<td>-</td>
				</tr>
				<tr>
					<td>
						<b>PLC</b> and power supply units: Inspect for loose or broken terminals. Check for the presence of contaminants like dirt, dust, grease, or rust. Replace as required.
					</td>
					<td>-</td>
					<td>-</td>
					<td>-</td>
					<td>X</td>
					<td>-</td>
					<td>-</td>
				</tr>
				<tr>
					<td>Push button bases: Check the wiring insulation for heat damage, small cracks, brittleness, or sections of missing insulation. Check for oil or chemical exposure, swelling or loose terminals.</td>
					<td>-</td>
					<td>-</td>
					<td>-</td>
					<td>X</td>
					<td>-</td>
					<td>-</td>
				</tr>
				<tr>
					<td>Contact relays: Check for broken or shading coils, dirty magnet faces, and loose terminals. During operation, verify no excessive arcing is present. Replace if damaged.</td>
					<td>-</td>
					<td>-</td>
					<td>-</td>
					<td>X</td>
					<td>-</td>
					<td>-</td>
				</tr>
				<tr>
					<td>Servo Motors: Inspect servo motor for damage or overheating. Verify the motor power and feedback connectors are tight. Check for any signs of impact on the outer shaft that may indicate damage to the bearings. Blower vents on motor must be kept clear for air circulation, clean any accumulated dirt.</td>
					<td>-</td>
					<td>-</td>
					<td>-</td>
					<td>X</td>
					<td>-</td>
					<td>-</td>
				</tr>
				<tr>
					<td>Check that all cables, terminals, and connectors are clean, undamaged, and tightly seated.</td>
					<td>-</td>
					<td>-</td>
					<td>-</td>
					<td>-</td>
					<td>-</td>
					<td>X</td>
				</tr>
				<tr>
					<td>Check contacts for wear. Contacts should be replaced when silver has become badly worn. Always replace contacts in complete sets to avoid misalignment and uneven contact pressure.</td>
					<td>-</td>
					<td>-</td>
					<td>-</td>
					<td>-</td>
					<td>-</td>
					<td>X</td>
				</tr>
				<tr>
					<td>Check all electrical cables and connections for signs of damage or deterioration and make sure all connections are tight and secure.</td>
					<td>-</td>
					<td>-</td>
					<td>-</td>
					<td>-</td>
					<td>-</td>
					<td>X</td>
				</tr>
			</tbody>
			<tfooter id="pager" className="pager" style={{}}>
				<form>
					<FaAngleDoubleLeft size={30} style={{ color: '#000', margin: '.25rem .5rem' }} className="first" alt="button" />
					<FaAngleLeft size={30} style={{ color: '#000', margin: '.25rem .5rem' }} className="prev" alt="button" />
					<input type="text" className="pagedisplay" alt="button" />
					<FaAngleRight size={30} style={{ color: '#000', margin: '.25rem .5rem' }} className="next" alt="button" />
					<FaAngleDoubleRight size={30} style={{ color: '#000', margin: '.25rem .5rem' }} className="last" alt="button" />
					<select className="pagesize">
						<option selected="selected" value="10">
							10
						</option>
						<option value="20">20</option>
						<option value="30">30</option>
					</select>
				</form>
			</tfooter>
		</table>
	);
};

const ElectricalTable = styled(TableComp)``;

export default ElectricalTable;
